export default __webpack_public_path__ + "static/media/bookmark-dark.ec6acf16.svg";